import { Component } from "react";
import * as React from "react";
import { YearGrouping } from "../../../models/SchoolWorkloadConfig";

export interface YearGroupingCardProps {
    className?: string;
    onDrop: (item: YearGrouping) => void;
    yearGroupingItem: YearGrouping;
}

interface YearGroupingCardState {
}

export default class YearGroupingCard extends Component<YearGroupingCardProps, YearGroupingCardState>
{

    constructor(props: Readonly<YearGroupingCardProps>) {
        super(props);

        this.state = {
        }
    }

    public componentDidMount() {
    }


    public render() {
        return (
            <div className={`card card--thin card--padded card--margin-small flex-row ${this.props.className ? this.props.className : ""}`}
                key={this.props.yearGroupingItem.name}
                onDrop={() => {this.props.onDrop(this.props.yearGroupingItem!)}}
                onDragOver={(e) => e.preventDefault()}>

                <div className={"flex-row flex-item--flex-1"}>
                    <span className={"flex-item--flex-1"}>{this.props.yearGroupingItem.name}</span>
                </div>
                {this.props.children}
            </div>
        );
    }
}